/* Hot Girls Care — theme.js */

// Sticky nav shadow
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Mobile nav
(function () {
  const toggle = document.querySelector('.site-header__menu-toggle');
  const mobileNav = document.querySelector('.site-header__mobile-nav');
  const closeBtn = document.querySelector('.mobile-nav-close');
  if (!toggle || !mobileNav) return;
  const open  = () => { mobileNav.classList.add('open');    toggle.setAttribute('aria-expanded', 'true'); };
  const close = () => { mobileNav.classList.remove('open'); toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
})();

// Cart count
(function () {
  const badges = document.querySelectorAll('[data-cart-count]');
  if (!badges.length) return;
  function updateCart() {
    fetch('/cart.js').then(r => r.json())
      .then(cart => badges.forEach(el => { el.textContent = cart.item_count; }))
      .catch(() => {});
  }
  updateCart();
  document.addEventListener('cart:updated', updateCart);
})();

// Add to cart
(function () {
  const form = document.querySelector('[data-product-form]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const btn = form.querySelector('.product-page__add');
    const original = btn.textContent;
    btn.textContent = 'Adding…'; btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added!';
        document.dispatchEvent(new Event('cart:updated'));
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
      })
      .catch(() => { btn.textContent = 'Error — try again'; btn.disabled = false; });
  });
})();
